import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  smallLabel: {
    lineHeight: 18,
  },
  sectionCentered: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  loader: {
    flex: 1,
    marginHorizontal: 16,
  },
  loaderContainer: {
    flex: 1,
    backgroundColor: Colors.white,
    borderRadius: 6,
    justifyContent: 'center',
    overflow: 'hidden',
    margin: 5
  },
})
